import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { sortTableDateCreacion } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarDependencias, filtarDependencias } from '../../actions/dependencias';

import FiltrosDependencias from './FiltrosDependencias';
import EliminarDependencia from './EliminarDependencia';

const Dependencias = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Dependencias',
            path: '/dependencias'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.dependencias);

    const [dependencias, setDependencias] = useState([]);

    const [dependenciaEliminar, setDependenciaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        },
        {
            name: 'Cuentas de usuario',
            sortable: true, 
            selector: row => row.usuarios,
        },
        {
            name: 'Descripción',
            sortable: true, 
            selector: row => row.descripcion,
            grow: 2, 
            wrap: true
        },
        {
            name: 'Fecha de creación',
            sortable: true, 
            sortFunction: sortTableDateCreacion, 
            cell: item => new Date(item.creacion).toLocaleDateString(
                'es-MX',
                { year: 'numeric', month: 'long', day: 'numeric' }
            ),
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarDependencia(row)}><i className="fas fa-trash text-danger"></i></button>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/dependencias/editar/${row._id}`}><i className="fas fa-edit text-warning"></i></Link>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/dependencias/detalles/${row._id}`}><i className="fas fa-circle-info text-info"></i></Link>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/dependencias/usuarios/${row._id}`}><i className="fas fa-users text-info"></i></Link>
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtarDependencias(true));
    }

    /* Eliminar dependencia */
    const handleEliminarDependencia = (dependencia) => {
        setDependenciaEliminar(dependencia);
    }

    useEffect(() => {
        dispatch(buscarDependencias({
            nombre: null,
            categoria: null,
            status: null,
            fecha_inicio: null,
            fecha_fin: null
        }));
    }, []);

    useEffect(() => {
        setDependencias(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosDependencias/>
            <EliminarDependencia dependencia={dependenciaEliminar} reestablecerDependencia={handleEliminarDependencia} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="mb-3 mt-5">Dependencias</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary me-2" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>

                        <Link to="/dependencias/nueva">
                            <button className="btn btn-primary">Agregar dependencia</button>
                        </Link>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={dependencias}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Dependencias;